import { useEffect, useState } from 'react';
import sessionService from '../services/session.service';
import { FALLBACK_MAESTRO_FIELDS } from '../utils/maestroSettings';

// One request per page load, shared by every component that asks — the field
// config is global and changes rarely.
let fieldsPromise = null;

const loadSessionFields = () => {
    if (!fieldsPromise) {
        fieldsPromise = sessionService.listSessionFields()
            .then((res) => (Array.isArray(res?.data) ? res.data : FALLBACK_MAESTRO_FIELDS))
            .catch(() => {
                fieldsPromise = null; // retry on the next mount
                return FALLBACK_MAESTRO_FIELDS;
            });
    }
    return fieldsPromise;
};

/**
 * Enabled Maestro setup fields (GET /v1/session-fields), for the session
 * create/edit form. Starts from the built-in defaults so the form never waits
 * on the request, and keeps them if it fails.
 * @returns {Object[]}
 */
export function useSessionFields() {
    const [fields, setFields] = useState(FALLBACK_MAESTRO_FIELDS);

    useEffect(() => {
        let cancelled = false;
        loadSessionFields().then((loaded) => { if (!cancelled) setFields(loaded); });
        return () => { cancelled = true; };
    }, []);

    return fields;
}
